import Cone from '@/assets/graphical-elements/cone.svg'
import {cn} from '@/lib/utils'
import {type IconProps} from '../types'

export const ConeIcon = ({className}: IconProps) => <Cone className={cn('fill-current', className)} />
